import * as types from '../types/authorTypes';
import * as authorServices from '../../services/authorServices';

// Fetch all authors (with optional language/region)
export const fetchAuthors = (params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_AUTHORS_REQUEST });
  try {
    const response = await authorServices.getAllAuthors(params);
    dispatch({ 
      type: types.FETCH_AUTHORS_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while fetching authors';
    dispatch({ type: types.FETCH_AUTHORS_FAILURE, payload: errorMessage });
  }
};

// Fetch author by slug (with optional language and region)
export const fetchAuthorBySlug = (slug, lang = null, region = null) => async (dispatch) => {
  dispatch({ type: types.FETCH_AUTHOR_BY_SLUG_REQUEST });
  try {
    const response = await authorServices.getAuthorBySlug(slug, lang, region);
    dispatch({ 
      type: types.FETCH_AUTHOR_BY_SLUG_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while fetching the author';
    dispatch({ type: types.FETCH_AUTHOR_BY_SLUG_FAILURE, payload: errorMessage });
  }
};

// Fetch articles by author
export const fetchAuthorArticles = (slug, params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_AUTHOR_ARTICLES_REQUEST });
  try {
    const response = await authorServices.getAuthorArticles(slug, params);
    dispatch({
      type: types.FETCH_AUTHOR_ARTICLES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while fetching author articles';
    dispatch({ type: types.FETCH_AUTHOR_ARTICLES_FAILURE, payload: errorMessage });
  }
};

// Create author (Admin only)
export const createAuthor = (authorData) => async (dispatch) => {
  dispatch({ type: types.CREATE_AUTHOR_REQUEST });
  try {
    const response = await authorServices.createAuthor(authorData);
    dispatch({ 
      type: types.CREATE_AUTHOR_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while creating the author';
    dispatch({ type: types.CREATE_AUTHOR_FAILURE, payload: errorMessage });
  }
};

// Update author (Admin only)
export const updateAuthor = (id, authorData) => async (dispatch) => {
  dispatch({ type: types.UPDATE_AUTHOR_REQUEST });
  try {
    const response = await authorServices.updateAuthor(id, authorData);
    dispatch({ 
      type: types.UPDATE_AUTHOR_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while updating the author';
    dispatch({ type: types.UPDATE_AUTHOR_FAILURE, payload: errorMessage });
  }
};

// Delete author (Admin only)
export const deleteAuthor = (id) => async (dispatch) => {
  dispatch({ type: types.DELETE_AUTHOR_REQUEST });
  try {
    await authorServices.deleteAuthor(id);
    dispatch({ type: types.DELETE_AUTHOR_SUCCESS, payload: id });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while deleting the author';
    dispatch({ type: types.DELETE_AUTHOR_FAILURE, payload: errorMessage });
  }
};


